import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import CoreComponent from "./CoreComponent";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import { IObject, IHolder } from "../interfaces";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { arrayToFormData, normalize } from "../utils/functions";

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    objects: IObject[],
    date_from: string,
    archive_date: string,
    to_date: string,
    limit: number,
    pagination: any,
    query: string,
    ids: number[],
    type: string,
    sort: string,
    isLoading: boolean,
    isArchiving: boolean,
    isOpen: boolean,
    currentPage: number,
    holder: IHolder
}

class ArchiveHolder extends CoreComponent<any, any> {
    state: IState = {
        objects: [],
        date_from: "",
        to_date: "",
        archive_date: "",
        limit: 30,
        pagination: null,
        query: "",
        ids: [],
        type: "",
        sort: "",
        isLoading: true,
        isOpen: false,
        isArchiving: false,
        currentPage: 1,
        holder: null
    }

    constructor(props: any) {
        super(props);

    }

    componentDidMount() {
        let _this = this;

        $(".datepicker").datepicker({
            startView: 1,
            minViewMode: 1,
            language: "ru",
            format: "yyyy-mm",
        }).on('changeDate', function (e: any) {
            if (e.target.name == "date_from")
                _this.setState({
                    date_from: e.target.value
                }, () => {
                    _this.loadObjects(_this.props.match.params.id);
                });
            else if (e.target.name == "to_date")
                _this.setState({
                    to_date: e.target.value
                }, () => {
                    _this.loadObjects(_this.props.match.params.id);
                });
            else if (e.target.name == 'archive_date')
                _this.setState({
                    archive_date: e.target.value
                });
        });

        $(".operator").select2();
    }

    async componentWillMount() {
        this.loadObjects(this.props.match.params.id);
    }

    async componentWillReceiveProps(nextProps: any) {
        let { search } = nextProps;

        this.loadObjects(nextProps.match.params.id, search);
    }

    async loadObjects(id: number, search: string = undefined) {
        cancel && cancel();

        if (!search && this.props.search)
            search = this.props.search;

        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;
            let limit = this.state.limit * this.state.currentPage;

            url = `${config.api}/archive/composition?limit=${limit}&user_id=${id}`;

            if (this.state.date_from) {
                url += `&date_from=${this.state.date_from}`;
            }

            if (this.state.to_date) {
                url += `&to_date=${this.state.to_date}`;
            }

            if (this.state.sort) {
                url += `&sort=${this.state.sort}`;
            }

            if (this.state.type) {
                url += `&type=${this.state.type}`;
            }

            if (search) {
                url += `&search=${search}`;
            }

            let res = await Axios.get(url, {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            });

            if (!this.isUnmounted) {
                if (!res.data.holder) {
                    toast("Партнер не найден в архиве", { type: "error" });
                    this.props.history.goBack();
                    return;
                }

                this.setState({
                    objects: res.data.models,
                    archive_date: res.data.date_from,
                    date_from: res.data.date_from,
                    to_date: res.data.to_date,
                    pagination: res.data.pagination,
                    holder: res.data.holder,
                    isLoading: false
                });


            }
        })
    }

    setOrder(sort: string) {
        this.setState({
            type: this.state.sort != sort ? "asc" : (this.state.type == "asc" ? "desc" : "asc"),
            sort
        }, () => {
            this.loadObjects(this.props.match.params.id);
        });
    }

    showMore() {
        this.setState({
            currentPage: this.state.currentPage + 1
        }, () => {
            this.loadObjects(this.props.match.params.id);
        });
    }

    async delete() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(`${config.api}/archive/delete-object`, arrayToFormData({ ids: this.state.ids }));

                if (response.data && response.data.length > 0)
                    this.setState({
                        objects: this.state.objects.filter((object: IObject) => !response.data.includes(object.id.toString())),
                        ids: []
                    });

                toast("Объекты удалены: " + response.data.length, { type: "success" });
            } else {
                toast("Выберите объектов", { type: "error" });
            }
        }
    }


    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div>
                <div className="crm-holders">
                    <div className="wrapper" style={{ maxWidth: "1370px" }}>
                        <NavLink className="crm-holders__back" to="/admin/archive/holders">
                            Назад
                        </NavLink>
                        <span className="crm-holders__title">Партнер —— {this.state.holder?.full_name} —— Обьекты</span>
                        <div className="crm-holders__headline">
                            <div className="crm-holders__buttons">

                            </div>
                            <div className="crm-holders__count">
                                <img src="img/Group 205.svg" alt="" />
                                <select
                                    id="select_page"
                                    style={{ width: "70px" }}
                                    className="numm"
                                    value={this.state.limit}
                                    onChange={(e: any) => {
                                        this.setState({
                                            limit: Number.parseInt(e.target.value)
                                        }, () => {
                                            this.loadObjects(this.props.match.params.id);
                                        })
                                    }}
                                >
                                    <option value="15">15</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="100000">Все</option>
                                </select>

                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginLeft: "50px",
                                    }}
                                >
                                    Дата:
                                    <div className="input-group date">
                                        <input type="text" className="form-control datepicker" autoComplete="off" name="date_from" defaultValue={this.state.date_from} />
                                        <img src="img/Icon awesome-calendar-alt.svg" alt="" />
                                        <div className="input-group-addon">
                                            <span className="glyphicon glyphicon-th"></span>
                                        </div>
                                    </div>
                                    <div className="block-line"></div>
                                    <div className="input-group date">
                                        <input type="text" className="form-control datepicker" autoComplete="off" name="to_date" defaultValue={this.state.to_date} />
                                        <img src="img/Icon awesome-calendar-alt.svg" alt="" />
                                        <div className="input-group-addon">
                                            <span className="glyphicon glyphicon-th"></span>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div style={{ display: "flex" }}>
                                <a
                                    role="button"
                                    onClick={() => {
                                        this.delete();
                                    }}
                                    style={{ margin: "0", marginRight: "15px" }}
                                    className="btn-del"
                                >
                                    Удалить
                                </a>

                                <NavLink to={"/admin/archive/transactions/" + this.props.match.params.id} className="crm-button mr-0" role="button">
                                    Транзакции
                                </NavLink>

                            </div>
                        </div>

                        <div className="crm-list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <input type="checkbox" onChange={() => {
                                                if (this.state.ids.length != this.state.objects.length) {
                                                    this.setState({
                                                        ids: this.state.objects.map((holder: IObject) => holder.id)
                                                    })
                                                } else {
                                                    this.setState({
                                                        ids: []
                                                    })
                                                }
                                            }} checked={this.state.ids.length == this.state.objects.length} />
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("id");
                                            }}>ID</a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("artist");
                                            }}>
                                                Автор
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("name");
                                            }}>
                                                Название
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("rate");
                                            }}>
                                                Ставка
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("views");
                                            }}>
                                                Кол-во <br /> просмотров
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("co-author");
                                            }}>
                                                Со-автор
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("place");
                                            }}>
                                                Площадка
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("currency");
                                            }}>
                                                Доход <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("youtube_id");
                                            }}>
                                                Source ID <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <img src="img/crm-youtube.svg" alt="" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!this.state.isLoading && this.state.objects.length == 0 && <tr><td colSpan={11}>{t("Ничего не найдено")}</td></tr>}
                                    {this.state.isLoading && <tr><td colSpan={11}>{t("Загрузка данных")}</td></tr>}
                                    {this.state.objects.map((object: IObject, i: number) => {
                                        return <tr key={i}>
                                            <td>
                                                <input type="checkbox" checked={!!this.state.ids.find((id: number) => id == object.id)} onChange={(e: any) => {
                                                    if (e.target.checked) {
                                                        this.setState({
                                                            ids: [...this.state.ids, object.id]
                                                        });
                                                    } else {
                                                        this.setState({
                                                            ids: this.state.ids.filter((id: number) => id != object.id)
                                                        });
                                                    }
                                                }} />
                                            </td>
                                            <td>{object.id}</td>
                                            <td>
                                                <NavLink to={"/admin/archive/holder/" + object.holder?.id}>{object.holder?.full_name}</NavLink>
                                            </td>
                                            <td>{normalize(object.name)}</td>
                                            <td>{object.rate} %</td>
                                            <td>{object.views}</td>
                                            <td>{object.coholders.map((holder: IHolder, ii: number) => <NavLink key={ii} to={"/admin/archive/holder/" + holder.id}>{holder.full_name}</NavLink>)}</td>
                                            <td>{object.place}</td>
                                            <td className="text-green">$ {Number.parseFloat(object.doxod.toString()).toFixed(3).slice(0, -1)}</td>
                                            <td title={object.youtube_id}>{normalize(object.youtube_id)}</td>
                                            <td>
                                                {object.place == "YouTube" && <a href={"https://youtu.be/" + object.youtube_id} target="_blink">
                                                    <img src="img/crm-youtube.svg" alt="" />
                                                </a>}
                                                {object.place != "YouTube" && object.youtube_id.startsWith("103") && <img src="img/ico1.svg" width="15" alt="" />}
                                                {object.place != "YouTube" && object.youtube_id.startsWith("A") && <img src="img/ico2.svg" width="15" alt="" />}
                                            </td>
                                        </tr>;
                                    })}
                                </tbody>
                            </table>
                            <div className="text-center p-3">
                                {this.state.objects.length > 0 && this.state.objects.length < (this.state.pagination?.totalCount) && <a role="button" className="spec-color fs-12" onClick={() => {
                                    this.showMore();
                                }}>Показать ещё...</a>}
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
        search: state.search,
    };
})(withTranslation()(ArchiveHolder));
